import React from "react";
import UpSellWidgetCustom from "../components/UpSellWidgetCustom";
import useArticlePopupModel from "../hooks/useArticlePopupModel";
import { UpsellWidgetModelProvider } from "../hooks/useUpsellWidgetModelContext";

const UpsellPopupArticleDetails = () => {
    const model = useArticlePopupModel()
    return (
        <UpsellWidgetModelProvider model={model}>
            <UpSellWidgetCustom />
        </UpsellWidgetModelProvider>
    );
};

export default UpsellPopupArticleDetails;